import React, { createContext, useContext } from 'react';

// Crear el contexto
const UserContext = createContext();

// Hook personalizado para usar el contexto
export const useUserContext = () => {
  return useContext(UserContext);
};

export default UserContext;
